// extracted by mini-css-extract-plugin
export var backButton = "NavigationMobile-module--backButton--23166";
export var backButtonContainer = "NavigationMobile-module--backButtonContainer--a5f8a";
export var childLinksContainer = "NavigationMobile-module--childLinksContainer--7b785";
export var childLinksInnerContainer = "NavigationMobile-module--childLinksInnerContainer--f032c";
export var genericLink = "NavigationMobile-module--genericLink--18aaf";
export var linkChevron = "NavigationMobile-module--linkChevron--800b5";
export var linkContainer = "NavigationMobile-module--linkContainer--01505";
export var linkContainerWithIcon = "NavigationMobile-module--linkContainerWithIcon--a452f";
export var root = "NavigationMobile-module--root--4eb19";